import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { of, throwError } from 'rxjs';
import { ICreateOrderRequest } from 'ngx-paypal';


@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  // Cambiar API
  constructor(private http: HttpClient) { }

  generateOrder(id_cart: number, paymentMethod: string, redsysMethod: string = 'card') {
    const url = paymentMethod == 'totem' ? `${AppSettings.API_URI_V2}/totem/orders` : `${AppSettings.API_URI_V2}/orders`;
    return this.http.post<any>(url, { id_cart: id_cart, paymentMethod: paymentMethod, redsys_method: redsysMethod }).pipe(
      map(data => {
        return data;
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  paymentByPaylands(id_order: number, card: any) {
    const url = `${AppSettings.API_URI_V2}/orders/${id_order}/payment`;
    const payload = {
      direct: card !== null,
      id_card: +card
    };    
    return this.http.post<any>(url, payload).pipe(
      map((data) => { return data }),
      catchError(err => { return throwError(() => err); })
    );
  }
}
